import { render, staticRenderFns } from "./Login.vue?vue&type=template&id=487d5ce0&scoped=true"
import script from "./Login.vue?vue&type=script&lang=js"
export * from "./Login.vue?vue&type=script&lang=js"
import style0 from "./Login.vue?vue&type=style&index=0&id=487d5ce0&prod&lang=scss&scoped=true"
import style1 from "./Login.vue?vue&type=style&index=1&id=487d5ce0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "487d5ce0",
  null
  
)

export default component.exports